import slick from '@accessible360/accessible-slick';
import $ from 'jQuery';

export default function () {
	$(function() {
		image_text_carousel();
	});

	const slickDefaults = {
		adaptiveHeight: false,
	};

	class Slider {
    /**
     * Slider Constructor
     * @param {HTML Element} element Element to transform into a slick slider.
     * @param {object} options Optional settings to overwrite the defaults.
     */
     constructor(element, options) {
      // Grabs reference to the passed in element.
      this.element = element;

      // We can pass in alternate options to overwrite the defaults.
      this.settings = { ...slickDefaults, ...options };

      // Sets a slider variable from the returned slick slider instance built.
      this.slider = this.build();

      // Calls a utility ready function when everything is done.
      this.ready();
    }

    /**
     * Builds out a slick slider from the element and the settings.
     * @returns jQuery Element
     */
    build() {
    	return $(this.element).slick(this.settings);
    }

    /**
     * Utility function to add a ready class to the element.
     */
    ready() {
     	this.element.classList.add('ready');
    }
  }

  function image_text_carousel() {
   	const $carousel = $('.block--text-image-carousel');

   	if ($carousel.length) {
   		$('.text-image-carousel--slider', $carousel).each(function() {
   			const $thisSlider = $(this);
   			let el = $thisSlider[0];
   			const $sliderContainer = $thisSlider.closest('.text-image-carousel--images');

   			const $pagerContainer = $thisSlider.closest('.text-image-carousel--images').find('.slick--controls__pagination');
   			const $prevButton = $sliderContainer.find('.slider--arrow--prev');
   			const $nextButton = $sliderContainer.find('.slider--arrow--next');

   			const slickSettings = {
   				slidesToShow: 1,
   				slidesToScroll: 1,
   				dots: true,
   				arrows: true,
   				fade: true,
   				infinite: true,
   				speed: 700,
					arrowsPlacement: 'afterSlides',
	        prevArrow: $prevButton,
	        nextArrow: $nextButton,
	        appendDots: $pagerContainer,
	        dotsClass: 'slick--pagination', // Slick generates a <ul.carousel-pagination> within the appendDots container
	        customPaging: function (slider, i) {
	          const slideNumber = (i + 1);
	          const totalSlides = slider.slideCount;
	          return '<button class="pagination-control"><span class="visually-hidden">View slide ' + slideNumber + ' of ' + totalSlides + '</span></button>';
	        },
        };

        if (!el.Slider) {
        	el.Slider = new Slider(el, slickSettings);
        }
      });
   	}
  }
}